import { actionCopyFr } from "./actionCopy";
import { listCopyFr } from "./listCopy";

export const patientsCopyFr = {
    patients: "Patients",
    navPatientsDescription: "Gérez tous vos patients au même endroit.",
    patientFallback: "Patient",
    action: "Action",
    trackerEntry: "Saisie de suivi",
    patientsError: "Erreur patients",
    error: "Erreur",
    tabActive: "Actifs",
    tabPending: "En attente",
    tabInactive: "Inactifs",
    search: actionCopyFr.search,
    searchPatientsAria: "Rechercher des patients",
    searchForPatient: "Rechercher un patient",
    searchDescription: "Recherchez par nom, e-mail, date de naissance, numéro de dossier hospitalier ou nom de journal",
    searchPlaceholder: "Rechercher par nom, e-mail, date de naissance, numéro de dossier...",
    noResultsFound: "Aucun résultat",
    trySearchingHint: "Essayez de rechercher par nom, e-mail, date de naissance ou numéro de dossier hospitalier",
    enterSearchTerm: "Saisissez un terme de recherche pour trouver des patients",
    loadingDiaries: "Chargement des journaux...",
    errorLoadingDiaries: (message) => `Erreur lors du chargement des journaux : ${message}`,
    unknownPatient: "Patient inconnu",
    dateOfBirthLabel: "Date de naissance",
    noDiariesOnPage: "Aucun journal sur cette page",
    showingDiaries: (start, end, total) => `Journaux ${start} à ${end} sur ${total}`,
    emptyFirstPatientTitle: "Invitez votre premier patient",
    emptyFirstPatientDescription:
        "Choisissez une configuration de journal, vérifiez les détails, puis envoyez une invitation. Sa progression apparaîtra ici.",
    emptyFirstPatientCta: "Ajouter votre premier journal",
    emptyFirstPatientHelpLink: "Comment inviter un patient ?",
    emptyTabTitle: (tabLabel) => `Aucun journal ${tabLabel.toLowerCase()}`,
    emptyTabDescription:
        "Les journaux des autres onglets restent disponibles. Changez d'onglet, ou invitez un autre patient.",
    notDefined: "Non défini",
    columnDiaryStatus: "Statut du journal",
    columnStartDate: "Date de début",
    columnPatientName: "Nom du patient",
    columnOrganisation: listCopyFr.organisation,
    columnLabels: listCopyFr.labels,
    columnDateOfBirth: listCopyFr.dateOfBirth,
    columnHospitalNumber: "Numéro de dossier hospitalier",
    columnRead: "Lu",
    filters: actionCopyFr.filters,
    filterDiariesAria: "Filtrer les journaux",
    viewSettings: "Paramètres d'affichage",
    viewSettingsDescription:
        "Choisissez la portée des journaux, le statut, les cliniciens avec qui ils sont partagés, les étiquettes et les filtres d'organisation pour cette liste.",
    sharedWithClinicians: "Partagé avec des cliniciens",
    diaryStatus: "Statut du journal",
    selectStatuses: "Sélectionner des statuts",
    labels: listCopyFr.labels,
    organisation: listCopyFr.organisation,
    save: actionCopyFr.save,
    apply: actionCopyFr.apply,
    sortDiariesTitle: "Trier les journaux",
    sortDiariesDescription:
        "Choisissez le champ et l'ordre pour cette liste. Le tri s'applique à tous les journaux de l'onglet actuel, et pas seulement à cette page.",
    diaryScope: "Portée des journaux",
    directAccess: "Accès direct",
    allDiariesInOrganisation: "Tous les journaux de mon organisation",
    selectClinicians: "Sélectionner des cliniciens",
    selectLabels: "Sélectionner des étiquettes",
    selectOrganisations: "Sélectionner des organisations",
    sortDiariesAria: "Trier les journaux",
    sortBy: "Trier par",
    order: "Ordre",
    sortAscending: "Croissant",
    sortDescending: "Décroissant",
    sortState: "État",
    sortStartDate: "Date de début",
    sortFirstName: "Prénom",
    sortLastName: "Nom",
    sortDateOfBirth: "Date de naissance",
    sortHospitalNumber: "Numéro de dossier hospitalier",
    read: "Lu",
    unread: "Non lu",
    noDiarySelected: "Aucun journal sélectionné",
    refreshDiary: "Actualiser le journal",
    noDiaryFound: "Aucun journal trouvé.",
    diaryCouldNotLoad: "Impossible de charger le journal.",
    profileCouldNotLoad: "Impossible de charger le profil.",
    diaryDetails: "Détails du journal",
    patientDetails: "Détails du patient",
    unknownState: "État inconnu",
    edit: actionCopyFr.edit,
    done: actionCopyFr.done,
    none: actionCopyFr.none,
    contact: "Contact",
    noContactPerson: "Aucune personne de contact",
    lastEntry: (relative) => `Dernière saisie ${relative}`,
    diaryOrganisation: "Organisation du journal",
    organisationAndContact: "Organisation et contact",
    editCareDetails: "Modifier les détails des soins",
    labelsStudyTrial: "Étiquettes (étude / essai)",
    contactName: "Nom du contact",
    contactLabel: (name) => `Contact : ${name}`,
    nameLabel: "Nom",
    emailLabel: "E-mail",
    openLink: "Ouvrir le lien",
    dateRangeToNow: (start) => `${start} à aujourd'hui`,
    dateRangeTo: (start, end) => `${start} au ${end}`,
    informationToComplete: "Informations à compléter",
    clinicianTasks: (entryCount, formCount) =>
        `Vous avez ${entryCount === 1 ? "1 saisie à effectuer" : `${entryCount} saisies à effectuer`} dans ${
            formCount === 1
                ? "1 formulaire que l'équipe doit remplir."
                : `${formCount} formulaires que l'équipe doit remplir.`
        }`,
    completeNextForm: "Remplir le formulaire suivant",
    completeForm: (title) => `Remplir ${title}`,
    questionnaire: "Questionnaire",
    more: actionCopyFr.more,
    moreActions: "Plus d'actions",
    moreActionsAria: "Plus d'actions",
    printDiary: "Imprimer le journal",
    shareDiary: "Partager le journal",
    openFullScreen: "Ouvrir en plein écran",
    messageHistory: "Historique des messages",
    deleteDiary: "Supprimer le journal",
    deleteDiaryTitle: "Supprimer le journal",
    deleteDiaryDescription: "Voulez-vous vraiment supprimer ce journal ?",
    cancel: actionCopyFr.cancel,
    delete: actionCopyFr.delete,
    updateDiary: "Mettre à jour le journal",
    addToDiary: "Ajouter au journal",
    addEvent: "Ajouter un événement",
    addConsent: "Ajouter un consentement",
    addQuestionnaire: "Ajouter un questionnaire",
    addFromTemplate: "Ajouter depuis un modèle",
    addEventDescription: "Ajoutez une intervention et associez-la à une date existante, ou créez-en une nouvelle.",
    addConsentDescription: "Associez un consentement à une intervention, ou ajoutez-en un avec sa propre date.",
    addQuestionnaireDescription:
        "Ajoutez un questionnaire et associez-le à une date existante, ou créez-en une nouvelle.",
    addFromTemplateDescription: "Appliquez un modèle enregistré à ce journal.",
    addConsentTitle: "Ajouter un consentement",
    addConsentDescriptionLong: "Choisissez une intervention, ou ajoutez un consentement avec sa propre date.",
    selectProcedureDate: "Intervention",
    notForAnEvent: "Sans lien avec un événement",
    consentDate: "Date",
    noProcedureDatesForConsent: "Ajoutez d'abord une intervention.",
    addEventFirst: "Ajoutez d'abord un événement",
    selectConsent: "Consentement",
    selectConsentHelp: "Choisissez un consentement publié à ajouter à ce journal.",
    noPublishedConsents:
        "Aucun consentement publié n'est disponible. Un administrateur peut en publier un dans le générateur de consentements.",
    consentRoles: "Qui doit signer",
    consentRolesHelp: "Les personnes sélectionnées seront invitées à signer ce consentement.",
    saveConsent: "Ajouter le consentement",
    savingConsent: "Ajout du consentement…",
    existingDateGroup: "Cela s'est-il produit à la même date que",
    newDate: "Aucune des dates ci-dessus",
    newDateHelp: "",
    pickExistingDateHelp: "",
    markAsReviewed: "Marquer comme examiné",
    endDiary: "Clôturer le journal",
    reinstate: "Réactiver",
    contactPatient: "Contacter le patient",
    endDiaryTitle: "Clôturer le journal",
    endDiaryNotifyQuestion: "Souhaitez-vous en informer le patient ?",
    justEndDiary: "Clôturer sans notifier",
    endDiaryAndNotify: "Clôturer et notifier le patient",
    markReviewedTitle: "Marquer comme examiné",
    markReviewedNotifyQuestion: "Souhaitez-vous informer le patient que son journal a été examiné ?",
    justMarkReviewed: "Marquer comme examiné sans notifier",
    notifyPatient: "Notifier le patient",
    from: "De",
    to: "À",
    subject: "Objet",
    emailBody: "Corps de l'e-mail",
    send: actionCopyFr.send,
    sending: actionCopyFr.sending,
    emailSentSuccess: "E-mail envoyé avec succès",
    emailSentDescription: "Le patient a été notifié",
    emailSendFailed: "Échec de l'envoi de l'e-mail",
    seeYourPatients: "Voir vos patients",
    seeYourPatientsDescription: "Suivez la progression de vos patients et gérez leurs journaux",
    goToPatients: "Aller aux patients",
    goingToPatients: "Redirection vers les patients...",
    reliableEmailWarning: "Pour une remise fiable, nous recommandons Gmail, Outlook ou iCloud.",
    entryRecordedTitle: "Saisie enregistrée avec succès",
    entryRecordedPending: (count) =>
        `Il reste ${count} ${count === 1 ? "saisie en attente" : "saisies en attente"} pour ce patient. Veuillez vous assurer que toutes les évaluations requises sont terminées.`,
    entryRecordedComplete:
        "Toutes les saisies requises pour ce patient ont été effectuées. Le dossier du patient est maintenant à jour.",
    continueToNextEntry: "Passer à la saisie suivante",
    returnToPatient: "Retour au patient",
    loadingTemplates: "Chargement des modèles…",
    addToDiaryTitle: "Ajouter au journal",
    addToDiaryDescription: "Ajoutez une intervention, un consentement ou un questionnaire, ou partez d'un modèle.",
    addManually: "Ajouter manuellement",
    addManuallyDescription:
        "Saisissez pas à pas les détails de l'intervention et du questionnaire, sans utiliser de modèle.",
    chooseTemplate: "Choisir un modèle",
    chooseTemplateDescription:
        "Sélectionnez un modèle enregistré pour préremplir les détails de l'intervention et du questionnaire de ce journal.",
    reviewTemplate: "Vérifier le modèle",
    reviewTemplateDescription: "Confirmez les détails ci-dessous avant de les ajouter à ce journal.",
    confirmAndContinue: "Confirmer et continuer",
    notifyPatientTitle: "Notifier le patient ?",
    intervention: "Intervention",
    openingTemplateProcedure: "Ouverture de l'intervention du modèle…",
    existingQuestionnaires: "Questionnaires existants",
    continueWithAllQuestionnaires: "Continuer avec tous les questionnaires",
    upcomingEntries: "Saisies à venir",
    noUpcomingEntries: "Aucune saisie à venir.",
    moreEntriesSummary: (count) => `... ${count} saisies de plus ...`,
    unlocks: (date) => `Débloqué le ${date}`,
    diaryEnded: "Journal clôturé",
    failedToEndDiary: "Échec de la clôture du journal",
    tableSettingsSaved: "Paramètres du tableau enregistrés",
    diaryAlreadyRead: "Journal déjà lu",
    diaryReviewedSubject: "Journal examiné",
    newDiary: "Nouveau journal",
    searchTemplatesPlaceholder: "Rechercher par intervention, zone ou questionnaire...",
    noTemplatesYet: "Vous n'avez pas encore de modèle. Créez-en un pour commencer à inviter des patients.",
    noTemplatesMatch: "Aucun modèle ne correspond à votre recherche.",
    searchTemplatesShort: "Rechercher des modèles...",
    procedureFilterInjection: "Injection",
    procedureFilterSurgery: "Chirurgie",
    procedureFilterShockwave: "Ondes de choc",
    procedureFilterConsultation: "Consultation",
    procedureFilterProduct: "Produit",
    checkingActiveQuestionnaires: "Recherche de questionnaires actifs...",
    stopQuestionnairesDescription:
        "Arrêtez les questionnaires en cours avant d'en ajouter un nouveau, ou continuez avec tous les questionnaires actifs.",
    noActiveQuestionnairesDescription: "Aucun questionnaire actif. Continuez pour en ajouter un nouveau.",
    stopping: "Arrêt...",
    stopAllCurrentQuestionnaires: "Arrêter tous les questionnaires en cours",
    stopOnly: (name) => `Arrêter uniquement ${name}`,
    stopJoined: (list) => `Arrêter ${list}`,
    stopTrackerAria: (name) => `Arrêter ${name}`,
    checkingActiveBeforeTemplate: "Recherche de questionnaires actifs avant la confirmation du modèle…",
    templateExistingTrackersDescription:
        "Cochez ceux que vous souhaitez arrêter avant d'ajouter depuis ce modèle, ou continuez avec tous les questionnaires actifs.",
    newPatientDiary: "Nouveau journal patient",
    newPatientDiaryDescription: "Choisissez un modèle, vérifiez la configuration, puis invitez votre patient.",
    createTemplate: "Créer un modèle",
    favourites: "Favoris",
    allTemplates: "Tous les modèles",
    needFiltersHint: "Besoin de filtres ou de gérer les modèles ?",
    browseAllTemplates: "Parcourir tous les modèles",
    cc: "Cc",
    saving: "Enregistrement…",
    interventionTypeQuestion: "Quel type d'intervention ?",
    selectInterventionRequired: "Veuillez sélectionner un type d'intervention",
    questionnairesLabel: "Questionnaires",
    continueLabel: "Continuer",
    notifyPatientUpdatedDescription:
        "Le modèle a été ajouté au journal. Souhaitez-vous envoyer un message au patient au sujet de cette mise à jour ?",
    noJustFinish: "Non, terminer simplement",
    yesNotifyPatient: "Oui, notifier le patient",
    diaryUpdatedFromTemplate: "Journal mis à jour à partir du modèle",
    couldNotApplyTemplate: "Impossible d'appliquer le modèle",
    updateMessageTitle: "Envoyer un message au patient ?",
    updateMessageDescription: "Envoyer un message au patient après l'enregistrement.",
    noJustSave: "Non, enregistrer simplement",
    yesSendMessage: "Oui, envoyer un message",
    saveAndMessagePatient: "Enregistrer et écrire au patient",
    saveOnly: "Enregistrer",
    updateQuestionnairesTitle: "Questionnaires",
    updateQuestionnairesDescription: "Sélectionnez les questionnaires et les calendriers de suivi",
    selectQuestionnaire: "Sélectionner un questionnaire",
    selectQuestionnaireHelp: "À quelles questions le patient doit-il répondre ?",
    selectSchedule: "Sélectionner un calendrier",
    selectScheduleHelp: "Quand le patient doit-il remplir le questionnaire ?",
    addAnotherQuestionnaire: "Ajouter un autre questionnaire",
    continueWithoutQuestionnaires: "Continuer sans questionnaires",
    referenceDateTitle: "Date",
    referenceDateDescription: "Définissez la date de début du traitement ou de la période de suivi.",
    contactStepDescription: "Qui est la personne de contact ?",
    questionnaireWithIndex: (index: number) => `Questionnaire ${index}`,
};
